/* eslint-disable */
import session from './session';

export default {
  getFMSUnitValue(value) {
    return session.post(`/api/v1/search/fms/?search=${value}`);
  },
  getFIOValue(value) {
    return session.post(`/api/v1/search/fio/?search=${value}`);
  },
  getAddressValue(value) {
    return session.post(`/api/v1/search/address/?search=${value}`);
  },
};
